<ng-container *ngIf="!module._destroy">
  <ion-item class="clickable" #currentItem (click)="select(currentItem, module, $event)">
    <span slot="start" [ngSwitch]="module.type">
      <mits-icon *ngSwitchCase="'ChecklistManagement::Modules::GalleryModule'" name="image"></mits-icon>
      <mits-icon *ngSwitchCase="'ChecklistManagement::Modules::BooleanModule'" name="log-off"></mits-icon>
      <mits-icon *ngSwitchCase="'ChecklistManagement::Modules::SelectModule'" name="select"></mits-icon>
      <mits-icon *ngSwitchCase="'ChecklistManagement::Modules::StringModule'" name="details-less"></mits-icon>
      <mits-icon *ngSwitchCase="'ChecklistManagement::Modules::TextareaModule'" name="menu-boxed"></mits-icon>
      <mits-icon *ngSwitchCase="'ChecklistManagement::Modules::NumberModule'" name="edit-exposure"></mits-icon>
      <mits-icon *ngSwitchDefault name="assign"></mits-icon>
    </span>
    <span data-test-id="title">{{ displayTitle }}</span>
  </ion-item>
  <ion-list *ngFor="let dep of module?.dep">
    <ng-container *ngIf="!dep._destroy">
      <ion-item class="clickable" #currentItem (click)="select(currentItem, dep, $event)" data-test-id="dependency">
        <span slot="start">
          <mits-icon name="code-slash"></mits-icon>
        </span>
        <span i18n>Wenn: <span class="valueText">{{ dep.value }}</span></span>
      </ion-item>
      <div class="insetModule">
        <ch-module *ngFor="let depModule of dep.modules" [module]="depModule"
          (selected)="select($event.htmlElement, $event.item, $event.clickEvent)"></ch-module>
      </div>
    </ng-container>
  </ion-list>
</ng-container>